import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Instagram } from "./Icons/Instagram";
import { TopNav } from "./TopNav";

function Jourpage({ props }) {
  const data = useStaticQuery(graphql`
    query {
      allContentfulJourney {
        nodes {
          article {
            article
          }
        }
      }
    }
  `);

  const {
    allContentfulJourney: {
      nodes: [{ article }],
    },
  } = data;

  return (
    <>
      <main className="journey--main">
        <TopNav path={props.location.pathname} />
        <div className="blog--wrapper">
          <h1>My Design Journey</h1>
          <ReactMarkdown>{article.article}</ReactMarkdown>
          <a href="https://www.instagram.com/yad_dev_design/">
            <Instagram /> Check out more works
          </a>
        </div>
      </main>
    </>
  );
}

export { Jourpage };
